// extracted by mini-css-extract-plugin
export default {"base":"Surveillance_base__b1GHA","header":"Surveillance_header__3gKbo","content":"Surveillance_content__KuNH1","body":"Surveillance_body__JUDp+"};